import { render, staticRenderFns } from "./MenuTabSkins.vue?vue&type=template&id=5d1f8144&"
import script from "./MenuTabSkins.vue?vue&type=script&lang=js&"
export * from "./MenuTabSkins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports